<template>
  <component
    :is="tag"
    v-show="!init || current"
  >
    <slot />
  </component>
</template>

<script>
import { inject, computed } from '@vue/composition-api'

export default {
  inheritAttrs: false,
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    tag: {
      type: String,
      default: 'div',
    },
  },
  setup({ multiple }, { attrs }) {
    const SYMBOL_KEY = Symbol.for('filter')
    const { item, items, init } = inject(SYMBOL_KEY)
    const filtered = computed(() =>
      items.value.filter(id => id === attrs.value)
    )
    const show = computed(() => filtered.value.includes(attrs.value))
    const current = computed(() =>
      multiple ? show.value : item.value === attrs.value
    )
    return {
      init,
      current,
    }
  },
}
</script>

<style lang="scss" scoped></style>
